import { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  // octa-skeleton tem shimmer com brilho deslizando (em vez de só pulse)
  return <div className={cn('octa-skeleton rounded-xl', className)} {...props} />;
}
